<template>
  <div class="container">
    <h1>Craniosacrale Energiebalance am Menschen</h1>

    <p>Mein Methodenkoffer setzt sich aus den Elementen von</p>
     <ul class="list">
       <li>Craniosacralen Energiebalance</li>
       <li><a href="https://www.ncmt.at/ncmt-akademie/ncmt">NCMT nach Johannes Randolf <span class="ncmt"></span></a></li>
       <li>Orthobionomie</li>
     </ul>
    <p>zusammen und enthält Konzepte von Isopathie sowie sensorischer Integration.</p>

<p>Verletzungen, Traumen oder Operationen führen oft erst deutlich später zu merkbaren Problemen, die dann aber 
      oftmals nicht mehr in Zusammenhang mit der ursprünglichen Ursache gesehen werden. Durch eine Anwendung können 
      unter anderem Gewebstraumen und gespeicherte Informationen im Muskelgedächtnis gelöst, aber auch Beckenschiefstände 
      und Schonhaltungen korrigiert werden.</p>

    <Slider :data="content" />   

    <p><b>Meine Anwendungen haben sich über die Jahre bei folgenden Beschwerden und Themenfeldern bewährt:</b></p>
    
    <ul class="list">
      <li>Myofasciale Dysbalancen des Rücken-, Schulter-, Becken- und Kieferbereichs und damit einhergehende 
        Beschwerden wie Spannungskopfschmerzen, Nacken-, Rückenschmerzen sowie Taubheitsgefühl in Armen und Beinen</li>
      <li>Wiederherstellung des Energieflusses bei energetischen Weiterleitungsstörungen, hervorgerufen durch 
        physische oder emotionale Traumata (zB. nach Unfällen oder Operationen)</li>
      <li>Unterstützung des Selbstheilungsprozesses nach operativen Eingriffen durch Bindegewebsmobilisierende Techniken</li>
      <li>Lösen von stressbedingten muskulären Blockaden</li>
      <li>als sinnvolle Ergänzung zur Physiotherapie</li>
    </ul>
    

    <p>Eine Anwendung wirkt ebenso auf das emotionale Wohlbefinden. Körperspannungen, welche mit seelischen Traumata 
      korrespondieren, können dabei aufgelöst werden.</p>

    <p>Ich empfehle den Rest des Tages ruhig anzugehen, um dem Körper ausreichend Zeit für Selbstheilungsprozesse zu geben.</p>

    <router-link :to="{ path: 'energiebalance#uebersicht' }" class="block margin-tb align-right">zurück zur Übersicht</router-link> 

  </div>
</template>

<script>
import Slider from "./shared/Slider.vue";

export default {
  name: "CranioMensch", //this is the name of the component
   metaInfo() {
        return { 
            title: "Craniosacrale Energiebalance für Menschen - Katharina Herda",
            meta: [
                { name: 'description', content:  'Craniosacrale Energiebalance unterstützt den Körper sich selbst von Schmerzen und Blockaden zu befreien, indem der natürliche Fluss wiederhergestellt wird.'},
                { property: 'og:title', content: "Craniosacrale Energiebalance für Menschen - Katharina Herda"},
                { property: 'og:description', content: 'Craniosacrale Energiebalance unterstützt den Körper sich selbst von Schmerzen und Blockaden zu befreien, indem der natürliche Fluss wiederhergestellt wird.'},    
                { property: 'og:image', content: 'src/img/assets/slider-mensch/image20.jpg'},
                { property: 'og:url', content: 'www.herda.at/energiebalance-mensch'}

            ]
        }
    },
    components: {
    "Slider": Slider,
  },
  
  data() { 
    return {
      content: {
        heading: 'Impressionen von der Craniosacralen Energiebalance am Menschen', 
        slides: [{ className: 'slider-mensch-1', htmlContent: `<span class="sr-only">Katharina Herda führt sanfte Regulationen an der Schulter eines Klienten durch</span>`
          }, 
          { className: 'slider-mensch-2', htmlContent: `<span class="sr-only">Katharina Herda löst Verspannungen im Nackenbereich der Klientin</span>`
          }, 
          { className: 'slider-mensch-3', htmlContent: `<span class="sr-only">Katharina Herda behandelt das Hüftgelenk der Klientin</span>`
          },
          { className: 'slider-mensch-4', htmlContent: `<span class="sr-only">Katharina Herda führt einen Muskelfuntionstest durch</span>`
          },
          { className: 'slider-mensch-5', htmlContent: `<span class="sr-only">Katharina Herda löst Spannungen im Bereich des Zwerchfells der Klientin</span>`
          },
          { className: 'slider-mensch-6', htmlContent: `<span class="sr-only">Katharina Herda testet die Brustwirbelsäule der Klientin nach Blockaden ab</span>`
          },
          { className: 'slider-mensch-7', htmlContent: `<span class="sr-only">Katharina Herda gleicht Dysbalancen im Unterarm des Klienten aus</span>`
          },
          { className: 'slider-mensch-8', htmlContent: `<span class="sr-only">Katharina Herda mit Freude bei Ihrer Arbeit am Klienten</span>`
          },
          { className: 'slider-mensch-9', htmlContent: `<span class="sr-only">Katharina Herda gleich Spannungen im ISG des Klienten aus</span>`
          }
          
        ]

      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CranioMensch.vue